// src/utils/axios.js 

import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'https://www.covrly.net/api/v1';

const axiosServices = axios.create({
  baseURL: API_BASE_URL,      
  // timeout: 10000,             
});

axiosServices.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.dispatchEvent(new Event('admin-session-expired'));
    }
    return Promise.reject(error);
  }
);

export default axiosServices;
